<template>
    <div class="d-flex align-items-center">
        <div class="chart_box">
            <label for="circumference">Circumference (mm)</label>
            <div class="select_block">
                <select v-model="size" class="form-select" id="circumference">
                    <option value="1">48.1</option>
                    <option value="2">49.0</option>
                    <option value="3">50.0</option>
                    <option value="4">50.9</option>
                    <option value="5">51.8</option>
                    <option value="6">52.8</option>
                    <option value="7">54.0</option>
                    <option value="8">55.0</option>
                    <option value="9">55.9</option>
                    <option value="10">56.9</option>
                    <option value="11">57.8</option>
                    <option value="12">59.1</option>
                    <option value="13">60.0</option>
                    <option value="14">60.9</option>
                    <option value="15">61.9</option>
                    <option value="16">62.8</option>
                    <option value="17">63.8</option>
                    <option value="18">64.7</option>
                    <option value="19">66.0</option>
                    <option value="20">66.9</option>
                </select>
            </div>
        </div>
        <div class="chart_box">
            <label for="indiaSize">India Size</label>
            <div class="select_block">
                <select v-model="size" class="form-select" id="indiaSize">
                    <option value="1">8</option>
                    <option value="2">9</option>
                    <option value="3">10</option>
                    <option value="4">11</option>
                    <option value="5">12</option>
                    <option value="6">13</option>
                    <option value="7">14</option>
                    <option value="8">15</option>
                    <option value="9">16</option>
                    <option value="10">17</option>
                    <option value="11">18</option>
                    <option value="12">19</option>
                    <option value="13">20</option>
                    <option value="14">21</option>
                    <option value="15">22</option>
                    <option value="16">23</option>
                    <option value="17">24</option>
                    <option value="18">25</option>
                    <option value="19">26</option>
                    <option value="20">27</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script setup>
    const size = ref(1);
</script>



<style scoped>
.chart_box {
    width: 30%;
    margin-right: 2%;
}
.chart_box label {
    font-size: 14px;
    font-weight: 600;
}

@media(max-width: 767px){
    .chart_box {
        width: 50%;
    }
}
</style>